import PrivacyPage from './PrivacyPage';
export default PrivacyPage;